var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.082,
    height: 35.592,
    viewBox: "0 0 36.082 35.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(-930.918 -262.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-product-4614268",
    transform: "translate(929.918 258.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M35.4,45.989H2.651A1.651,1.651,0,0,1,1,44.343V19.631a.581.581,0,0,1,.581-.581h34.89a.581.581,0,0,1,.581.581V44.343A1.651,1.651,0,0,1,35.4,45.989ZM2.163,20.213v24.13a.494.494,0,0,0,.488.488H35.4a.494.494,0,0,0,.488-.488V20.213Z",
    transform: "translate(0 -6.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M-10073.5-9157.562v11.242l4.92-4.289,5.806,4.68v-11.633Z",
    transform: "translate(10087.401 9170.384)",
    fill: "#37a0da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M36.471,13.986H1.581a.586.586,0,0,1-.552-.768L3.692,5.3A1.651,1.651,0,0,1,5.256,4.17H32.8A1.651,1.651,0,0,1,34.36,5.3l2.692,7.92a.587.587,0,0,1-.581.768ZM2.39,12.823H35.663L33.256,5.664a.483.483,0,0,0-.459-.331H5.256a.483.483,0,0,0-.459.331Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M32.441,13.986H26.3a.587.587,0,0,1-.581-.622L26.3,4.711a.582.582,0,0,1,.581-.541h5a.582.582,0,0,1,.582.541l.581,8.653a.587.587,0,0,1-.6.622Zm-5.518-1.163h4.9l-.494-7.49H27.417Z",
    transform: "translate(-10.345 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M32.442,28.576l-3.083-2.371L26.3,28.576a.658.658,0,0,1-.582-.715v-8.1a.658.658,0,0,1,.582-.715h6.141a.658.658,0,0,1,.581.715v8.1a.658.658,0,0,1-.582.715Zm-5.559-2.083,2.476-1.918,2.5,1.918V20.479H26.883Z",
    transform: "translate(-10.345 -6.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M11.151,46.068a.581.581,0,0,1-.581-.581V37.461a.581.581,0,0,1,1.163,0v8.025A.581.581,0,0,1,11.151,46.068Z",
    transform: "translate(-4.005 -9.388)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M11.718,39.9a.582.582,0,0,1-.471-.238L9.933,37.874,8.712,39.566a.583.583,0,0,1-.942-.686l1.692-2.326a.581.581,0,0,1,.471-.244h0a.581.581,0,0,1,.471.244L12.189,39a.557.557,0,0,1-.471.9Z",
    transform: "translate(-2.786 -9.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M21.332,36.88a.582.582,0,0,0-.582.581v8.024a.582.582,0,0,0,1.163,0V37.461A.582.582,0,0,0,21.332,36.88Z",
    transform: "translate(-8.265 -9.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M21.884,36.3a.582.582,0,0,0-.471.238L20.1,38.331l-1.221-1.692a.593.593,0,0,0-.96.7l1.692,2.326a.582.582,0,0,0,.471.244h0a.582.582,0,0,0,.471-.244l1.785-2.448a.581.581,0,0,0-.471-.925Z",
    transform: "translate(-7.033 -3.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M49.221,47.623h-6.35a.581.581,0,1,1,0-1.163h6.35a.581.581,0,0,1,0,1.163Z",
    transform: "translate(-17.28 -14.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M49.221,52.663h-6.35a.581.581,0,1,1,0-1.163h6.35a.581.581,0,0,1,0,1.163Z",
    transform: "translate(-17.28 -16.582)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct2);
export default __webpack_public_path__ + "static/media/product2.5f272bc5d9f3682bfdae9056133f7625.svg";
export { ForwardRef as ReactComponent };